import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import the translations
import fr from './Locals/fr.json';
import en from './Locals/en.json';
import es from './Locals/es.json';
import ar from './Locals/ar.json';

i18n
  .use(LanguageDetector) // Detect language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      fr: {
        translation: fr,
      },
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
      ar: {
        translation: ar,
      },
    },
    lng: 'fr', // Default language
    fallbackLng: 'fr', // If detected language is not available, use 'fr'
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
    // Optional: to disable console warnings
    debug: false,
  });

export default i18n;
